<template>
  <div class="history-container">
    <div class="history-list" :style="{ maxHeight: listMaxHeight }">
      <div
        class="history-item"
        ref="historyItems"
        v-for="item in list"
        :key="item._id || item.text"
        @click="emits('select', item)"
      >
        <span class="history-item-text">{{ item.text }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { nextTick, onMounted, ref, watch } from "vue";
interface HistoryItem {
  _id?: string;
  text: string;
}

interface IProps {
  list: HistoryItem[];
  maxRows?: number;
}

const emits = defineEmits(["select"]);
const historyItems = ref<HTMLDivElement[]>([]);
const props = withDefaults(defineProps<IProps>(), {
  list: () => [],
  maxRows: 3
});

const listMaxHeight = ref<string | null>(null);

const calculateMaxHeight = () => {
  if (props.maxRows <= 0) {
    listMaxHeight.value = null;
    return;
  }

  if (historyItems.value && historyItems.value.length > 0) {
    const itemHeight = historyItems.value[0].clientHeight || 27;
    if (itemHeight > 0) {
      const GAP = 10;
      const maxHeight = itemHeight * props.maxRows + GAP * (props.maxRows - 1);
      listMaxHeight.value = `${maxHeight}px`;
    }
  }
};

onMounted(() => {
  calculateMaxHeight();
});

watch(
  () => props.list,
  async () => {
    await nextTick();
    calculateMaxHeight();
  },
  { deep: true }
);

watch(
  () => props.maxRows,
  () => {
    calculateMaxHeight();
  }
);

defineExpose({
  calculateMaxHeight
});
</script>

<style lang="scss" scoped>
.history-container {
  overflow: auto;
  height: 100%;
  box-sizing: border-box;
}

.history-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  overflow: hidden;
}

.history-item {
  flex: 0 1 auto;
  max-width: calc((100% - 10px) / 2);
  padding: 0 9px;
  height: 27px;
  box-sizing: border-box;
  background: #fafafa;
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
}

.history-item-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  color: #696969;
  font-family: var(--m-font-family-regular);
}
</style>
